import { ProductSelectionParamValuesDto } from "definitions/product-storage";
import { API } from "src/api.ts";

export interface GetParamValuesArgs {
  selectionId: number;
  key: string[];
  query?: string;
  limit?: number;
  caseSensitive?: boolean;
  signal?: AbortSignal;
}

// Прямой axios-вызов вместо reatomAsync: запрос параметризован комбинацией
// (selectionId, keys, query) и встроен в локальный useEffect конкретного
// MappingFieldRow — общий atom тут только мешал бы (давал гонки между рядами).
// Abort пробрасывается извне.
export const fetchProductSelectionParamValues = (
  args: GetParamValuesArgs,
): Promise<ProductSelectionParamValuesDto> =>
  API.productSelectionApi
    .productSelectionControllerGetParamValues(
      {
        selectionId: args.selectionId,
        key: args.key,
        query: args.query,
        limit: args.limit,
        caseSensitive: args.caseSensitive,
      },
      { signal: args.signal },
    )
    .then((response) => response.data);
